import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ThemeCustomizerService } from '../theme-customizer/theme-customizer.service';
import { HttpClientModule } from '@angular/common/http';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-instructors-style-two',
    templateUrl: './instructors-style-two.component.html',
})
export class InstructorsStyleTwoComponent implements OnInit {

    isToggled = false;

    constructor(
        public themeService: ThemeCustomizerService
    ) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    ngOnInit(): void { }

}